import { Outlet, createFileRoute } from '@tanstack/react-router';
import { ProductLogoMediumBusinessPartner as LogoBusinessPartner } from '@/components/Logo';
import type { TabWithIndicatorProps } from '@/components/Navigation/HeaderTabs';
import { ProductHeader } from '@/components/ProductHeader';
import { useTranslation } from '@/lib/i18n';
export const Route = createFileRoute('/_staff/business-partner/_list')({
  component: Layout
});
function Layout() {
  const {
    t
  } = useTranslation();
  const tabs = [{
    to: '/business-partner/overview',
    children: t('common.list.overview'),
    activeOptions: {
      exact: true
    }
  }, {
    to: '/business-partner',
    children: t('common.list.businessPartners'),
    activeOptions: {
      exact: true
    }
  }, {
    to: '/business-partner/alerts',
    children: t('common.list.alerts')
  }, {
    to: '/business-partner/contract-and-cost',
    children: t('common.list.contractAndCost')
  }, {
    to: '/business-partner/operation-activity',
    children: t('common.list.operationActivity')
  }, {
    to: '/business-partner/rule-and-policy',
    children: t('common.list.ruleAndPolicy')
  }, {
    to: '/business-partner/settings',
    children: t('common.list.settings')
  }] satisfies TabWithIndicatorProps[];
  return <div className="flex flex-col">
      <ProductHeader Logo={LogoBusinessPartner} name={t('pages.businessPartner.list.pageTitle')} tabs={tabs} type="resource" />
      <Outlet />
    </div>;
}